import { apiFetch } from "@/lib/api-client";

export interface LlmConfig {
  company_id: number;
  provider: string;
  model: string;
  has_api_key: boolean;
  base_url?: string;
  extra_json?: string;
  updated_at?: string;
}

export interface UpsertLlmPayload {
  provider: string;
  model: string;
  /** undefined=保留原值, ""=清空, 其他=覆盖 */
  api_key?: string;
  base_url?: string;
  extra_json?: string;
}

function withScope(path: string, scope?: string) {
  return scope ? `${path}${path.includes("?") ? "&" : "?"}scope=${encodeURIComponent(scope)}` : path;
}

export async function getLlmConfig(scope?: string) {
  return apiFetch<{ success: boolean; data: LlmConfig | null }>(
    withScope("/api/admin/llm-config", scope),
  );
}

export async function upsertLlmConfig(payload: UpsertLlmPayload, scope?: string) {
  return apiFetch<{ success: boolean }>(withScope("/api/admin/llm-config", scope), {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export interface TestResult {
  success: boolean;
  latency_ms?: number;
  sample_reply?: string;
  error?: string;
}

/** 测试已保存的配置; scope="global" 测全局默认 (company 0), 与 GET/PUT 同一约定 */
export async function testLlm(scope?: string) {
  return apiFetch<TestResult>(withScope("/api/admin/llm-config/test", scope), {
    method: "POST",
    timeoutMs: 60_000,
  });
}
